module.exports = __webpack_public_path__ + "img/15.061ef21e.webp";